<template>
  <div class="page-pay-notify-general"
       :class="{ 'show-padding-top': inAppWebView }"
  >
    <div v-if="!inAppWebView"
         class="page-pay-notify-general-page-header"
    >
      <div class="back">
        <ym-icon class="icon-back"
                 name="back"
                 @click="handleClickBack"
        />
      </div>
    </div>
    <div class="page-pay-notify-general-header">
      <h1 v-if="pageData.title"
          class="title"
      >
        <span>{{ pageData.title }}</span>
        <ym-icon class="icon"
                 name="round-tick"
        />
      </h1>
      <div class="info"
           v-ym-report:EXCHANGE_RECORD_EXCHANGE_CLICK="{ sn }"
           @click="handleOrderDetail"
      >
        <div class="desc">{{ pageData.desc }}</div>
        <div class="sub-title">{{ pageData.subTitle }}</div>
        <div class="course-detail-btn">
          {{ pageData.joinedProductLink.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isAppWebView, locationHref } from '@/utils';

  export default {
    name: 'PayNotifyExchangeMallShop',
    props: {
      pageData: {
        type: Object,
        required: true,
      },
      sn: {
        type: String,
        required: true,
      },
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      handleClickBack() {
        const { meta } = this.$route || {};
        const { back } = meta;
        if (back) {
          this.$router.replace(back);
          return;
        }
        this.$router.go(-1);
      },
      handleOrderDetail() {
        locationHref(this.pageData.joinedProductLink.path);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify-general {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @background-color-base;

    &.show-padding-top {
      padding-top: 200px;
    }

    &-page-header {
      width: 100%;
      height: 300px;
      background: #fed100;

      .back {
        width: 70px;
        height: 70px;
        margin: @size-base 0 0 @size-base;
      }

      .icon-back {
        margin-top: @size-base;
        color: @color-text-base;
      }
    }

    &-header {
      box-sizing: border-box;
      width: 690px;
      margin-top: -156px;
      margin-bottom: @size-small;
      padding: 0 @size-base;
      background: @color-white;
      border-radius: 12px;

      .title {
        margin: 0;
        padding: @size-extra-medium 0;
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          margin-left: @size-small;
          color: #ff8500;
          font-size: @font-size-largest;
        }
      }
      .info {
        box-sizing: border-box;
        width: 100%;
        padding: 80px 0 @size-extra-medium 0;
        border-top: 1px solid #eee;

        .desc {
          margin-bottom: @size-small;
          color: @color-text-base;
          font-size: @font-size-medium;
          line-height: 1;
          text-align: center;
        }
        .sub-title {
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-bold;
          line-height: 1.4;
          text-align: center;
        }
        .course-detail-btn {
          margin: 80px auto 0;
          width: 424px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-text-base;
          font-size: @font-size-medium;
          font-weight: @font-weight-bold;
          line-height: 1;
          background: #fed100;
          border-radius: 44px;
        }
      }
    }
  }
</style>
